class Elementor_Featured_Carousel {
    static instance;

    static getInstance() {
        if (!Elementor_Featured_Carousel.instance) {
            Elementor_Featured_Carousel.instance = new Elementor_Featured_Carousel();
        }
        return Elementor_Featured_Carousel.instance;
    }

    constructor() {
        $(window).on('elementor/frontend/init', () => {
            this.init();
        });
    }

    init() {
        elementorFrontend.hooks.addAction('frontend/element_ready/opal-featured-box.default', ($scope) => {
            let $carousel = $scope.find('.owl-carousel');
            if ($carousel.length > 0) {
                let data = $carousel.data('settings');
                $carousel.owlCarousel(Elementor_Carousel.setupData(data));
            }

        });
    }
}


Elementor_Featured_Carousel.getInstance();